import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Select, Form } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { unexpectedError, tailFormItemLayout, formItemLayout } from '../../../common_functions';
const CollectionLocationsForm = ({ props, onFinish, formRef, resetFilterData, showAdvanceSearchModal, resetFilters, disabled }) => {
  const { getItems } = props;
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [collections, setCollections] = useState([]);

  // Get collection data
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        await getCollections();
        await getLocations();
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    fetchLocations();
  }, [resetFilterData]);

  const resetFilters_2 = async () => {
    await resetFilters();
    await fetchLocations();
  };
  const fetchLocations = async () => {
    try {
      setLoading(true);
      await getLocations();
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const getCollections = async () => {
    const { data: collection_data } = await getItems('collections', {
      fields: ['id', 'name'],
      sort: '-id',
      limit: -1,
      filters: {
        associated_to: {
          _in: ['print', 'both'],
        },
      },
    });
    setCollections(collection_data);
  };
  const getLocations = async (collectionID = null) => {
    formRef.current.setFieldsValue({ locations: '' });
    let { data: locations_data } = await getItems('location', {
      fields: ['id', 'name'],
      sort: '-id',
      filters: collectionID ? { collections: { _eq: collectionID } } : {},
      limit: -1,
    });
    setLocations(locations_data);
  };

  return (
    // <Form
    //   ref={formRef}
    //   layout="vertical"
    //   className="collection-filter-form"
    //   onFinish={onFinish}
    //   {...formItemLayout}
    //   initialValues={{ layout: tailFormItemLayout }}
    // >
    //   <Row gutter={24}>
    //     <Col xs={24} sm={24} md={10} lg={10}>
    //       <Form.Item name="collections" label="Collection">
    //         <Select
    //           placeholder="Select collection"
    //           optionFilterProp="children"
    //           showSearch
    //           allowClear
    //           filterOption={(input, option) => option.children.includes(input)}
    //           onChange={getLocations}
    //         >
    //           {collections.map(col => {
    //             return <Select.Option value={col.id}>{col.name}</Select.Option>;
    //           })}
    //         </Select>
    //       </Form.Item>
    //     </Col>
    //     <Col xs={24} sm={24} md={10} lg={10}>
    //       <Form.Item name="locations" label="Locations">
    //         <Select
    //           placeholder="Select Location"
    //           optionFilterProp="children"
    //           showSearch
    //           allowClear
    //           filterOption={(input, option) => option.children.includes(input)}
    //         >
    //           {locations.map(col => {
    //             return <Select.Option value={col.id}>{col.name}</Select.Option>;
    //           })}
    //         </Select>
    //       </Form.Item>
    //     </Col>

    //     <Col xs={24} sm={24} md={4} lg={4}>
    //       <Form.Item {...tailFormItemLayout}>
    //         <Button type="primary" size="small" block htmlType="submit" style={{ marginTop: '28px' }}>
    //           Search
    //         </Button>
    //       </Form.Item>
    //     </Col>
    //   </Row>
    // </Form>
    <Form
      ref={formRef}
      layout="vertical"
      className="collection-filter-form"
      onFinish={onFinish}
      {...formItemLayout}
      initialValues={{ layout: tailFormItemLayout }}
    >
      <Row gutter={24} wrap>
        {/* Collection */}
        <Col xs={24} sm={24} md={showAdvanceSearchModal ? 8 : 10} lg={showAdvanceSearchModal ? 8 : 10}>
          <Form.Item name="collections" label="Collection">
            <Select
              placeholder="Select collection"
              showSearch
              allowClear
              style={{ width: '100%' }}
              filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
              onChange={getLocations}
            >
              {collections.map(col => (
                <Select.Option key={col.id} value={col.id}>
                  {col.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {/* Locations */}
        <Col xs={24} sm={24} md={showAdvanceSearchModal ? 8 : 10} lg={showAdvanceSearchModal ? 8 : 10}>
          <Form.Item name="locations" label="Locations">
            <Select
              placeholder="Select location"
              showSearch
              allowClear
              style={{ width: '100%' }}
              filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
            >
              {locations.map(loc => (
                <Select.Option key={loc.id} value={loc.id}>
                  {loc.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {/* Buttons */}
        {/* Only Search (no Advanced Search / Reset): sit inline with the two fields, on their line,
            with an empty label so the button lines up with the inputs. */}
        {!showAdvanceSearchModal && (
          <Col xs={24} sm={24} md={4} lg={4}>
            <Form.Item label=" " colon={false}>
              <Button type="primary" size="small" block htmlType="submit" icon={<SearchOutlined />}>
                Search
              </Button>
            </Form.Item>
          </Col>
        )}

        {/* Full row when Advanced Search and Reset sit beside Search — a fractional column is too
            narrow to fit all three with their icons side by side, so they'd wrap one per line. */}
        {showAdvanceSearchModal && (
          <Col span={24}>
            <Form.Item {...tailFormItemLayout} style={{ marginTop: 28 }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                <Button type="primary" size="small" htmlType="submit" icon={<SearchOutlined />} style={{ height: 42 }}>
                  Search
                </Button>

                <Button type="primary" size="small" icon={<SearchOutlined />} onClick={showAdvanceSearchModal} style={{ height: 42 }}>
                  Advanced Search
                </Button>

                <Button danger size="small" icon={<ReloadOutlined />} onClick={resetFilters_2} disabled={disabled} style={{ height: 42 }}>
                  Reset
                </Button>
              </div>
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};
export default CollectionLocationsForm;
